import { useState, useEffect } from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import LoadingScreen from "@/components/LoadingScreen";

const Gallery = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  const galleryImages = [
    {
      id: 1,
      src: "/images/news/orthopedie/1.png",
      alt: "Congrès d'Orthopédie - Session 1",
      title: "Congrès d'Orthopédie - Session 1",
      date: "Mai 2025"
    },
    {
      id: 2,
      src: "/images/news/orthopedie/2.png",
      alt: "Congrès d'Orthopédie - Session 2",
      title: "Congrès d'Orthopédie - Session 2",
      date: "Mai 2025"
    },
    {
      id: 3,
      src: "/images/news/orthopedie/4.png",
      alt: "Congrès d'Orthopédie - Session 3",
      title: "Congrès d'Orthopédie - Session 3",
      date: "Mai 2025"
    },
    {
      id: 4,
      src: "/images/news/somedian/1.png",
      alt: "Congrès SOMEDIAN - Session 1",
      title: "Congrès SOMEDIAN - Session 1",
      date: "Mai 2025"
    },
    {
      id: 5,
      src: "/images/news/somedian/2.png",
      alt: "Congrès SOMEDIAN - Session 2",
      title: "Congrès SOMEDIAN - Session 2",
      date: "Mai 2025"
    },
    {
      id: 6,
      src: "/images/news/somedian/3.png",
      alt: "Congrès SOMEDIAN - Session 3",
      title: "Congrès SOMEDIAN - Session 3",
      date: "Mai 2025"
    },
    {
      id: 7,
      src: "/images/news/6.jgp",
      alt: "Journée scientifique sur l’anémie",
      title: "Journée scientifique sur l’anémie",
      date: "Décembre 2024"
    },
    {
      id: 8,
      src: "/images/news/5.jgp",
      alt: "Journée scientifique sur l’anémie",
      title: "Journée scientifique sur l’anémie",
      date: "Décembre 2024"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* Hero Section */}
      <section className="relative flex items-center justify-center bg-cover bg-center min-h-[40vh]"
        style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/background.jpg')" }}>
        <div className="text-center px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Galerie Photos</h1>
          <p className="text-xl text-white max-w-2xl mx-auto">
            Découvrez nos moments forts et événements en images
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryImages.map((image) => (
            <div 
              key={image.id}
              className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer"
              onClick={() => setSelectedImage(image.src)}
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4">
                  <span className="text-white font-medium">{image.title} - {image.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full">
            <Button
              variant="ghost"
              className="absolute -top-12 right-0 text-white hover:text-blue-400"
              onClick={() => setSelectedImage(null)}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Fermer
            </Button>
            <img 
              src={selectedImage} 
              alt="Image agrandie"
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery; 